import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/slices/userSlices";
import { useEffect, useState } from "react";

export default function Logout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
    navigate("/");
  }, []);

  return (
    <div className="w-full h-full bg-cover bg-no-repeat relative overflow-hidden min-h-[727px]"></div>
  );
}
